import { useTheme } from '@simplywallst/ui-core';

import { line, curveMonotoneX } from 'd3-shape';

interface Props {
  x3: number;
  y3: number;
  x2: number;
  y2: number;
  x1: number;
  y1: number;
}

export const Connector = ({ x3, y3, x2, y2, x1, y1 }: Props) => {
  const theme = useTheme();
  const start: [number, number] = [x1, y1];
  const elbow: [number, number] = [x2, y2];
  const end: [number, number] = [x3, y3];
  const pathGenerator = line().curve(curveMonotoneX);
  const path = pathGenerator([start, elbow, end]);
  if (path === null) return null;
  return <path d={path} fill="none" stroke={theme.color.whiteRGBA(0.2)} />;
};
